import { Button } from "@mui/material";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import React, { useEffect, useState } from "react";
import { useTranslate } from "src/locales";
import { setSelectedOfficeId } from "../../../modules/auth/authenticationSlice";
import { closeAllTabs } from "../../../modules/auth/tabsSlice";
import { usePopover } from "../../../components/custom-popover";
import Iconify from "../../../components/iconify";
import { useNavigate } from "react-router-dom";
import OfficeSelectionPopover from "./selection-popover";

export default function OfficeSelection() {
    const navigate = useNavigate();
    const authState = useAppSelector((state) => state.auth);
    const dispatch = useAppDispatch();
    const { t } = useTranslate();
    const popover = usePopover();

    // Geçici seçim state'i (Tamam'a basılana kadar)
    const [tempSelectedId, setTempSelectedId] = useState<number | null>(null);

    // İlk yüklemede varsayılan şubeyi seç
    useEffect(() => {
        if (authState.user?.UserAssPriviliges && authState.user.UserAssPriviliges.length > 0 && !authState.selectedOfficeId) {
            const firstOffice = authState.user.UserAssPriviliges[0];
            if (firstOffice.ID) {
                dispatch(setSelectedOfficeId(firstOffice.ID));
            }
        }
    }, [authState.user, authState.selectedOfficeId, dispatch]);

    // Popover açıldığında mevcut seçili olanı temp state'e ata
    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setTempSelectedId(authState.selectedOfficeId);
        popover.onOpen(event);
    };

    const handleSelect = (id: number) => {
        setTempSelectedId(id);
    };

    const handleConfirm = (id: number) => {
        const targetId = Number(id);
        const currentId = authState.selectedOfficeId ? Number(authState.selectedOfficeId) : null;

        if (targetId !== currentId) {
            // Sadece şube değiştiğinde sekmeleri kapat ve URL'yi temizle
            dispatch(closeAllTabs());
            dispatch(setSelectedOfficeId(targetId));
            navigate('/');
        }

        popover.onClose();
    };

    const currentOffice = authState.user?.UserAssPriviliges?.find(
        (item) => Number(item.ID) === Number(authState.selectedOfficeId)
    );

    return (
        <>
            <Button
                onClick={(e: any) => handleOpen(e)}
                variant="outlined"
                sx={{
                    height: 40,
                    px: 1.5,
                    borderRadius: 1.25,
                    bgcolor: '#fff',
                    borderColor: '#F7F7F7',
                    fontWeight: '400',
                    '&:hover': {
                        bgcolor: 'rgba(99, 180, 255, 0.1)',
                    },
                }}
                endIcon={<Iconify icon={popover.open ? 'eva:chevron-up-fill' : 'eva:chevron-down-fill'} width={18} />}
            >
                {currentOffice?.OFFICE_NAME || t("select-office")}
            </Button>

            <OfficeSelectionPopover
                open={popover.open}
                onClose={popover.onClose}
                officeList={authState.user?.UserAssPriviliges || []}
                selectedId={tempSelectedId}
                onSelect={handleSelect}
                onConfirm={handleConfirm}
            />
        </>
    );
}
